// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { ROUTE_DEFINITIONS, getPath } from "routes/routes";

import { CustomerConfig } from "utils/ConfigTypes";

export const getHeaderLogoRoute = (config: CustomerConfig): string => {
  const routeName = config.headerConfig.headerLogo.route || "HOME";
  const route = ROUTE_DEFINITIONS[routeName];
  if (!route) {
    throw new Error(`No route ${routeName} for header logo`);
  }
  return getPath(route);
};
